// This file should only contain action type constants.
export const SET_REVIEWS = 'SET_REVIEWS';
export const SET_REVIEWS_INFO = 'SET_REVIEWS_INFO';
export const SET_CURR_AVG_AND_TOTAL_RATING = 'SET_CURR_AVG_AND_TOTAL_RATING';
export const SET_DEALER_ID = 'SET_DEALER_ID';
export const SET_STORE_ERROR = 'SET_STORE_ERROR';
export const SET_PAGE = 'SET_PAGE';
// filters
export const SET_REVIEWS_FILTERS = 'SET_REVIEWS_FILTERS';
export const UPDATE_RATING_FILTER = 'UPDATE_RATING_FILTER';
export const UPDATE_MODEL_FILTER = 'UPDATE_MODEL_FILTER';
export const UPDATE_TYPE_FILTER = 'UPDATE_TYPE_FILTER';
